import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AcademyCommonModule, PipesModule } from '@draeger-academy/common';
import { AcademyPresentationUiModule } from '@draeger-academy/presentation';
import { TranslateModule } from '@ngx-translate/core';
import { ServerErrorPageComponent } from './server-error-page.component';

// const routes: Routes = [{ path: '', component: ServerErrorPageComponent }];

@NgModule({
    declarations: [ServerErrorPageComponent],
    imports: [CommonModule, AcademyCommonModule, PipesModule, AcademyPresentationUiModule, TranslateModule.forChild()]
})
export class ServerErrorPageModule {}
